import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { FaHome, FaArrowLeft, FaExclamationTriangle, FaSearch } from 'react-icons/fa';
import '../../styles/NotFoundPage.css';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const [userRole, setUserRole] = useState(null);
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        // Detect user role from token
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                console.error('Token decode error:', error);
            }
        }

        // Auto redirect countdown
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleGoHome();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleGoHome = () => {
        // Redirect based on user role
        if (userRole === 1) {
            navigate('/kl');
        } else if (userRole === 0 || userRole === 2) {
            navigate('/admin');
        } else if (userRole === 3) {
            navigate('/publikator');
        } else {
            navigate('/');
        }
    };

    const handleGoBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            handleGoHome();
        }
    };

    const getHomeLabel = () => {
        switch (userRole) {
            case 1: return 'Dashboard K/L';
            case 0: return 'Dashboard Verifikator';
            case 2: return 'Dashboard Supervisor';
            case 3: return 'Dashboard Publikator';
            default: return 'Login';
        }
    };


    return (
        <div className="not-found-container">
            <div className="not-found-background">
                <div className="floating-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                    <div className="shape shape-4"></div>
                </div>
            </div>

            <div className="not-found-content">
                {/* Ilustrasi 404 */}
                <div className="not-found-illustration">
                    <div className="illustration-404">
                        <div className="number-4 number-left">4</div>
                        <div className="illustration-center">
                            <div className="astronaut">
                                <div className="astronaut-body">
                                    <div className="astronaut-helmet"></div>
                                    <div className="astronaut-suit"></div>
                                    <div className="astronaut-arms">
                                        <div className="arm-left"></div>
                                        <div className="arm-right"></div>
                                    </div>
                                    <div className="astronaut-legs">
                                        <div className="leg-left"></div>
                                        <div className="leg-right"></div>
                                    </div>
                                </div>
                                <div className="astronaut-flag">
                                    <div className="flag-pole"></div>
                                    <div className="flag"></div>
                                </div>
                            </div>
                            <div className="planet">
                                <div className="planet-surface"></div>
                                <div className="planet-crater crater-1"></div>
                                <div className="planet-crater crater-2"></div>
                                <div className="planet-crater crater-3"></div>
                            </div>
                            <div className="stars">
                                <div className="star star-1"></div>
                                <div className="star star-2"></div>
                                <div className="star star-3"></div>
                                <div className="star star-4"></div>
                                <div className="star star-5"></div>
                            </div>
                        </div>
                        <div className="number-4 number-right">4</div>
                    </div>
                </div>

                <h2 className="not-found-subtitle">
                    Halaman Tidak Ditemukan
                </h2>

                <p className="not-found-description">
                    Sepertinya Anda tersesat di ruang angkasa! Halaman yang Anda cari tidak dapat ditemukan.
                </p>

                <div className="not-found-actions">
                    <button 
                        className="btn btn-primary not-found-btn"
                        onClick={handleGoHome}
                    >
                        <FaHome className="me-2" />
                        {getHomeLabel()}
                    </button>

                    <button 
                        className="btn btn-outline-secondary not-found-btn"
                        onClick={handleGoBack}
                    >
                        <FaArrowLeft className="me-2" />
                        Kembali
                    </button>
                </div>

                <div className="not-found-countdown">
                    <p>
                        Otomatis kembali ke halaman utama dalam <span className="countdown-number">{countdown}</span> detik
                    </p>
                </div>
            </div>

            {/* Logo KSP */}
            <div className="not-found-logo">
                <img src="/ksp.png" alt="Logo KSP" />
            </div>
        </div>
    );
};

export default NotFoundPage;
